var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ApartmentTypeService } from './../../api/apartment-type.service';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ElementRef, OnDestroy, Injector } from '@angular/core';
import { PropertySearch } from './../../models/index';
import * as Raven from 'raven-js';
import { Subscription } from 'rxjs/Subscription';
import { BaseComponent } from '../base-component';
import { FbqService } from '../../analytics/fbq.service';
var AbstractApartmentTypeSearch = /** @class */ (function (_super) {
    __extends(AbstractApartmentTypeSearch, _super);
    function AbstractApartmentTypeSearch(injector, window) {
        var _this = _super.call(this, injector) || this;
        _this.window = window;
        _this.apartmentTypes = [];
        _this.page = 1;
        _this.apiLoading = false;
        _this.endOfList = false;
        _this.subscription = new Subscription();
        _this.sort = '';
        _this.router = injector.get(Router);
        _this.fbqService = injector.get(FbqService);
        _this.apartmentTypeService = injector.get(ApartmentTypeService);
        return _this;
    }
    AbstractApartmentTypeSearch.prototype.getPropertySearch = function () {
        return AbstractApartmentTypeSearch.propertySearch;
    };
    AbstractApartmentTypeSearch.prototype.notifyFb = function () {
        var contentName = 'ApartmentTypeSearch';
        if (AbstractApartmentTypeSearch.propertySearch.room_count)
            contentName += '_' + AbstractApartmentTypeSearch.propertySearch.room_count + 'rooms';
        this.fbqService.sendEvent('ViewContent', {
            content_name: contentName
        });
    };
    AbstractApartmentTypeSearch.prototype.refreshApartmentTypes = function () {
        this.page = 1;
        this.apartmentTypes = [];
        this.apiLoading = false;
        this.endOfList = false;
        this.notifyFb();
        Raven.captureBreadcrumb({
            message: 'refreshApartmentTypes',
            category: 'apartmentTypes infinite scroll'
        });
        return this.addApartmentType();
    };
    AbstractApartmentTypeSearch.prototype.addApartmentType = function () {
        var _this = this;
        if (this.apiLoading) {
            return;
        }
        this.apiLoading = true;
        var currentPage = this.page++;
        Raven.captureBreadcrumb({
            message: 'addApartmentType, page: ' + currentPage,
            category: 'apartmentTypes infinite scroll'
        });
        this.apartmentTypeService.getApartmentTypes(AbstractApartmentTypeSearch.propertySearch, this.sort, currentPage).then(function (apartmentTypes) {
            _this.apiLoading = false;
            Raven.captureBreadcrumb({
                message: 'addApartmentType API resonse, page: ' + currentPage,
                category: 'apartmentTypes infinite scroll'
            });
            if (currentPage === 1) {
                if (_this.apartmentTypes.length) {
                    Raven.captureMessage('ApartmentType list error: possbile duplication detected', { level: 'warning' });
                }
                _this.apartmentTypes = apartmentTypes;
            }
            else {
                _this.apartmentTypes = _this.apartmentTypes.concat(apartmentTypes);
            }
            if (apartmentTypes.length < 15) {
                _this.endOfList = true;
                return;
            }
        })
            .catch(function () { return _this.apiLoading = false; });
    };
    AbstractApartmentTypeSearch.prototype.search = function () {
        var _this = this;
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(function () {
            for (var field in AbstractApartmentTypeSearch.propertySearch) {
                if (AbstractApartmentTypeSearch.propertySearch[field] === null
                    || AbstractApartmentTypeSearch.propertySearch[field] === undefined) {
                    delete AbstractApartmentTypeSearch.propertySearch[field];
                }
            }
            if (_this.window) {
                _this.router.navigate([_this.window.location.pathname], {
                    queryParams: AbstractApartmentTypeSearch.propertySearch
                });
            }
        }, 200);
    };
    AbstractApartmentTypeSearch.prototype.onScroll = function () {
        if (this.window) {
            if (!this.endOfList && this.section.nativeElement.getBoundingClientRect().bottom - this.window.innerHeight < 0) {
                this.addApartmentType();
            }
        }
    };
    AbstractApartmentTypeSearch.prototype.ngOnDestroy = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
    };
    AbstractApartmentTypeSearch.prototype.resetFilters = function () {
        AbstractApartmentTypeSearch.propertySearch = new PropertySearch();
        if (!this.form.touched && !this.form.dirty) {
            this.search();
        }
    };
    AbstractApartmentTypeSearch.propertySearch = new PropertySearch();
    return AbstractApartmentTypeSearch;
}(BaseComponent));
export { AbstractApartmentTypeSearch };



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/abstract-apartment-types-search.model.ts.pre-build-optimizer.js